import { CorrenteCadastroZCO } from './ZCO/correnteRegrasCadastroZCO';
import { getParentescoByValue } from './ZCO/funcoesAuxiliaresZCO';

export async function regrasPorPlanoValidateOnSubmit(dependentes,plano,valuesForm,editar) {
    try {
        if (dependentes === '' || dependentes === null) {
            dependentes = [];
        }

        const dependentesParaValidacao = [...dependentes];

        switch (plano) {
        case 'ZCO':
        case 'ZCOC':
            if (!editar) {
                const dependenteTela = {
                    Idade: valuesForm.Idade,
                    Parentesco: getParentescoByValue(valuesForm.Parentesco).label
                };

                dependentesParaValidacao.push(dependenteTela);

                const correnteZCO = new CorrenteCadastroZCO(
                    dependentesParaValidacao
                )
                    .verificaTipoParentesco();
                const { arrayMsgsErro } = correnteZCO;

                return arrayMsgsErro;
            } else {
                const correnteZCO = new CorrenteCadastroZCO(
                    dependentes
                );

                const { arrayMsgsErro } = correnteZCO;

                return arrayMsgsErro;
            }

        default:
            return [];
        }
    } catch (error) {

    }
}
